import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { format } from "date-fns";

import { alpha, Box, Container, Stack, styled, Typography, Link as MUILink } from "@mui/material";

import { copyrightWrapper, flexContainer } from "./styles";
import { AppRoutes } from "types";
import { getEnvVarsStorage } from "helpers";
import { getAdditionalLinks } from "../config";

const FooterWrapper = styled("footer")(({ theme }) => ({
  borderTop: `1px solid ${alpha(theme.palette.common.black, 0.1)}`,
  backgroundColor: theme.palette.common.white,
}));

interface FooterProps {
  isAdditionalLinks?: boolean;
}

const Footer: React.FC<FooterProps> = ({ isAdditionalLinks = true }) => {
  const { t } = useTranslation("common");
  const envs = getEnvVarsStorage();
  const { termsLink, privacyLink } = getAdditionalLinks(envs);

  return (
    <FooterWrapper>
      <Box sx={copyrightWrapper}>
        <Container sx={flexContainer}>
          <Typography color="text.primary">
            &copy; {format(new Date(), "yyyy")}. {t("footer.copyright")}
          </Typography>

          {isAdditionalLinks && (
            <Stack direction={{ xs: "column", sm: "row" }}>
                <>
                  <a
                    style={{ textDecoration: "unset", color: "#0E1210", marginRight: "24px" }}
                    href={termsLink}
                    target="_blank"
                  >
                    {t("nav.termsConditions")}
                  </a>
                  <a
                    style={{ textDecoration: "unset", color: "#0E1210" }}
                    href={privacyLink}
                    target="_blank"
                  >
                    {t("nav.privacyPolicy")}
                  </a>
                </>
            </Stack>
          )}
        </Container>
      </Box>
    </FooterWrapper>
  );
};

export default Footer;
